<script>
export default {
  functional: true,

  render(h, { slots }) {
    return (
      <el-row type="flex" gutter={32} style={{ flexWrap: 'wrap' }}>
        <el-col sm={12}>{slots().default && slots().default[0]}</el-col>
        <el-col sm={12}>{slots().default && slots().default[1]}</el-col>
      </el-row>
    )
  }
}
</script>
